import React, { FC, useState, useEffect } from 'react';
import classNames from 'classnames';
import View from '../view';

interface ISwitchProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 激活时背景色，默认取 scss 变量 $ink-color-brand
   */
  color?: string;
  /**
   * 初始选中状态
   * @default false
   */
  defaultChecked?: boolean;
  /**
   * 指定当前是否选中
   */
  checked?: boolean;
  /**
   * 是否禁止点击
   * @default false
   */
  disabled?: boolean;
  /**
   * 选中状态变化时回调函数
   */
  onChange?: (value: boolean) => void;
}

const Switch: FC<ISwitchProps> = ({ className, defaultChecked = false, checked: propsChecked, disabled = false, color, onChange }) => {
  const [checked, setChecked] = useState<boolean>(typeof propsChecked !== 'undefined' ? propsChecked : defaultChecked);

  const rootCls = classNames(
    'ink-switch',
    {
      'ink-switch--on': checked,
      'ink-switch--disabled': disabled,
    },
    className,
  );

  const handleClick = () => {
    if (disabled) {
      return;
    }
    /**
     * props.checked 传入，为受控组件，通过 传入 checked 来更新本地 checked
     * props.checked 未传入，未非受控组件，使用内部状态更新
     */
    if (typeof propsChecked === 'undefined') {
      setChecked(!checked);
    }

    if (onChange) {
      onChange(!checked);
    }
  };

  useEffect(() => {
    if (typeof propsChecked !== 'undefined') {
      setChecked(propsChecked);
    }
  }, [propsChecked]);

  return (
    <View className={rootCls} style={{ backgroundColor: checked ? color : (null as any) }} onClick={handleClick}>
      <View className="ink-switch__node" />
    </View>
  );
};

export default Switch;
